<template>
  <div>
    <div class="pl-7 pt-4">
      <div class="font-primaria headline font-weight-bold fontColor1--text">
        {{ titulo }}
      </div>
      <div
        v-if="
          nameTab === 'Dados Cadastrais' ||
          (nameTab === 'Perfil') | (nameTab === 'Certificações')
        "
      >
        <div
          style="line-height: 8px;"
          class="font-secundaria subtitle-2 fontColor1--text"
          v-if="!$vuetify.breakpoint.xs"
        >
          Home > {{ paginaPassada }} > {{ codigoUnimed }} - {{ nomeDaUnimed }} >
          {{ nameTab }} >
          <span class="font-weight-bold"> {{ abaGeneric }} </span>
        </div>
        <div class="font-secundaria subtitle-2 fontColor1--text" v-else>
          Home > {{ paginaPassada }} > {{ codigoUnimed }} - {{ nomeDaUnimed }} >
          {{ nameTab }} >
          <span class="font-weight-bold"> {{ abaGeneric }} </span>
        </div>
      </div>
      <div v-else>
        <div
          style="line-height: 8px;"
          class="font-secundaria subtitle-2 fontColor1--text"
          v-if="!$vuetify.breakpoint.xs"
        >
          Home > {{ paginaPassada }} > {{ codigoUnimed }} - {{ nomeDaUnimed }} >
          <span class="font-weight-bold"> {{ nameTab }} </span>
        </div>
        <div class="font-secundaria subtitle-2 fontColor1--text" v-else>
          Home > {{ paginaPassada }} > {{ codigoUnimed }} - {{ nomeDaUnimed }} >
          <span class="font-weight-bold"> {{ nameTab }} </span>
        </div>
      </div>
    </div>

    <CardMinhaUnimed
      @loading="(value) => (loadingUnimed = value)"
      @change-tab="(obj) => changeTab(obj)"
      v-if="!loadingUnimed"
      :unimedId="codigoUnimed"
      ref="card"
    />

    <overlay-loading v-model="loadingUnimed" />
  </div>
</template>

<script>
import CardMinhaUnimed from './Shared/CardMinhaUnimed'
import Unimed from '@/services/Unimed'
import { EventBus } from '@/services/EventBus/EventBus'

export default {
  components: {
    CardMinhaUnimed
  },
  data() {
    return {
      idUnimed: -1,
      loadingUnimed: false,
      nameTab: 'Dados Cadastrais',
      nomeDaUnimed: ' ',
      codigoUnimed: '',
      paginaPassada: '',
      opcaoEditar: localStorage.getItem('optionEdit'),
      tokenBearer: localStorage.getItem('tokenBearer'),
      showMandatos: false,
      abaDados: 'Dados Cadastrais',
      abaPerfil: 'Beneficiários',
      abaGeneric: 'Dados Cadastrais'
    }
  },
  async beforeMount() {
    this.idUnimed = this.$route.params.idUnimed
    this.loadingUnimed = true

    this.idUnimed
      ? localStorage.setItem('idUnimed', this.idUnimed)
      : (this.idUnimed = localStorage.getItem('idUnimed'))

    const unimed = new Unimed(this.tokenBearer, this.$appConfig.config.API)

    await unimed
      .getConsulta(this.idUnimed)
      .then((response) => {
        response = response.data.conteudo[0]

        this.nomeDaUnimed = response.nomeFantasia
        this.codigoUnimed = response.codigo
        this.$idUnimed = response.id
        this.$codigoUnimed = response.codigo
      })
      .catch((err) => {
        console.error(err)
      })

    await this.getAbas()

    this.loadingUnimed = false
    await this.$nextTick()

    this.$refs.card.showMandatos(!this.showMandatos);

    const currentTab = this.$route.params.currentTab;
    if (currentTab != null) {
      EventBus.$emit('changeAbaMinhaUnimed', currentTab);
      this.nameTab = currentTab.tabName;
    }
  },
  async mounted() {
    EventBus.$on('changeIndexPerfil', (index) => {
      const swi = () => {
        switch (index) {
          case 0:
            return 'Beneficiários'
          case 1:
            return 'Cooperados'
          case 2:
            return 'Colaboradores'
        }
      }
      this.abaGeneric = swi()
    })

    EventBus.$on('changeIndexDados', (index) => {
      const swi = () => {
        switch (index) {
          case 0:
            return 'Dados Cadastrais'
          case 1:
            return 'Classificação'
          case 2:
            return 'Hierarquia'
          case 3:
            return 'Endereço'
        }
      }
      this.abaGeneric = swi()
    })

    EventBus.$on('changeIndexCertificacoes', (index) => {
      const swi = () => {
        switch (index) {
          case 0:
            return 'Certificações e Selos'
          case 1:
            return 'Iniciativas Institucionais'
          case 2:
            return 'Premiações de Mercado'
        }
      }
      this.abaGeneric = swi()
    })

    switch ((this.paginaPassada = localStorage.getItem('paginaPassada'))) {
      case 'home':
        this.paginaPassada = 'Minha Unimed'
        break
      case 'consultarUnimed':
        this.paginaPassada = 'Consultar Unimeds'
        break
      case 'novaUnimed':
        this.paginaPassada = 'Nova Unimed'
        break
      default:
        this.paginaPassada = ''
        break
    }
  },
  methods: {
    async getAbas() {
      const unimed = new Unimed(this.tokenBearer, this.$appConfig.config.API)

      await unimed
        .getAbas(this.$idUnimed)
        .then((responseAbas) => {
          this.showMandatos = responseAbas.data
        })
        .catch((err) => {
          console.error(err)
        })
    },
    changeTab(obj) {
      switch (++obj.tabIndex) {
        case 1:
          this.nameTab = 'Dados Cadastrais'
          break
        case 2:
          this.nameTab = 'Áreas'
          break
        case 3:
          this.nameTab = 'Perfil'
          break
        case 4:
          this.nameTab = 'Mandatos'
          break
        case 5:
          this.nameTab = 'Área de Ação'
          break
        case 6:
          this.nameTab = 'ANS'
          break
        case 7:
          this.nameTab = 'Certificações'
          break
        case 8:
          this.nameTab = 'Anexos'
          break
        case 9:
          this.nameTab = 'Histórico'
          break
        default:
          break
      }

      if(obj.options !== null) {
        if(obj.options.event === "changeIndexPerfil") {
          localStorage.setItem("changeIndexPerfil", obj.options.index);
        } else {
          localStorage.setItem("changeIndexPerfil", null);
        }
      }
    }
  },
  computed: {
    titulo() {
      if (this.paginaPassada === 'Minha Unimed') {
        return this.paginaPassada.toUpperCase()
      } else {
        return 'CONSULTAR UNIMEDS'
      }
    }
  }
}
</script>

<style lang="sass" scoped></style>
